import {
    ChangeDetectionStrategy,
    Component,
    SecurityContext,
    ViewEncapsulation,
    computed,
    inject,
    input,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'ui-m040-c025-footnote',
    standalone: true,
    imports: [],
    templateUrl: './m040-c025-footnote.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class M040C025FootnoteComponent {
    sanitizer = inject(DomSanitizer);
    data = input.required<{ sign: string; text: string }>();

    safeData = computed(() => {
        const data = this.data();
        return {
            sign: data.sign,
            text: this.sanitizer.sanitize(SecurityContext.HTML, data.text),
        };
    });
}
